import { render, staticRenderFns } from "./ApproverParent.vue?vue&type=template&id=8278d4dc"
import script from "./ApproverParent.vue?vue&type=script&lang=js"
export * from "./ApproverParent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports